export default "//yastatic.net/s3/distribution/pythia/frontend/_/0eef75b8f4ff2ea92ccc77fa7cc09195.png";